import React from 'react';

function TileContent({ icon, label, value }) {
  return (
    <>
      <span className='hsc-tile__icon row-center justify-center br14 fs-18 bg-white sb-blue-800'>
        {icon}
      </span>
      <span className='display-flex-column txt-left overflow-hidden'>
        <span className='hsc-tile__label gSemiBold fs-11 grey-600 uppercase'>
          {label}
        </span>
        <span className='gBold fs-16 grey-900 txt-single-line-ellipsis'>
          {value}
        </span>
      </span>
    </>
  );
}

export default TileContent;
